import React from 'react';
import {PagePadding} from '@components/SectionLayout';
import styled from 'styled-components';
import * as colors from '@styles/colors';
import * as fonts from '@styles/fonts';
import {media} from '@styles';
import ButtonGroup from '@components/Buttons/ButtonGroup';

type InfoBoxProps = React.PropsWithChildren<{
  image?: string;
  color?: string;
  backgroundColor?: string;
  maxWidth?: string;
  links?: object[];
  buttonWidth?: number;
}>;

const InfoBoxContainer = styled.section<{
  image?: string;
  backgroundColor?: string;
}>`
  ${props =>
    props.backgroundColor
      ? `background-color: ${`url(${props.backgroundColor});`}`
      : `background-color: ${colors.creme};`}
  ${props =>
    props.image
      ? `background-image: ${`url(${props.image});`}`
      : ''}
  background-size: cover;
  background-repeat: no-repeat;
  ${props => (props.image ? 'padding: 105px 0;' : 'padding: 50px 0;')}

  ${media.desktop`
    ${props => (props.image ? 'padding: 85px 0;' : 'padding: 30px 0;')}
  `}
`;

const InfoBoxTitleContainer = styled.div<{maxWidth?: string}>`
  display: flex;
  justify-content: center;
  max-width: ${props => (props.maxWidth ? props.maxWidth : `640px`)};
  margin: 0 auto;
`;

const InfoBoxTitle = styled.h4`
  text-align: center;
  color: ${props => (props.color ? props.color : `${colors.white}`)};
  font-size: 27px;
  font-weight: bold;
  font-family: ${fonts.tisapro};
  line-height: 34px;

  ${media.tablet`
    font-size: 1rem;
    line-height: 1.25rem;
  `}
`;

const InfoBoxContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoBox = (props: InfoBoxProps): JSX.Element => (
  <InfoBoxContainer backgroundColor={props.backgroundColor} image={props.image}>
    <PagePadding>
      <InfoBoxContentContainer>
        <InfoBoxTitleContainer maxWidth={props.maxWidth}>
          <InfoBoxTitle color={props.color}>{props.children}</InfoBoxTitle>
        </InfoBoxTitleContainer>
        {props.links ? (
          <ButtonGroup width={`${props.buttonWidth}px`} links={props.links} />
        ) : null}
      </InfoBoxContentContainer>
    </PagePadding>
  </InfoBoxContainer>
);

export default InfoBox;
